// extracted by css-extract-rspack-plugin
export default {"header":"header-YBayhO","content":"content-a7VYen","contentList":"contentList-GJ8pr_"};